import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios"
const StudentsCSLP = () => {
  const [inProcess, setInProcess] = useState(false);
  const syncStudents = () => {
    setInProcess(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "TeachersCSLP/SyncCSLPTeachers",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        toast.success("Sync Process Finished");
      } else {
        toast.error("Sync Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  return (
    <>
      <button
        className="btn btn-sm btn-success"
        onClick={() => syncStudents()}
        disabled={inProcess}
      >
        Sync Students
      </button>
    </>
  );
};

export default StudentsCSLP;
